import { flatten, isNil } from 'lodash';
/*
  PLEASE NOTE: These helpers are moved here from the API module to clear things outs. If we ever
  have time to refactor this properly, these should actually be methods of the related stores,
  and not these kind of external helper functions. Please do not add new functions here, but
  implement those on the stores themselves directly.
*/
export var SpaceTagToMarker = function (tag, floor) {
    var marker = {
        id: tag.id,
        move_layout_id: floor.id,
        marker_type: 'room',
        title: tag.title,
        coordinates: {
            positionX: tag.positionX,
            positionY: tag.positionY,
            openSpace: tag.openSpace,
        },
    };
    return marker;
};
export var TableTagToMarker = function (tag, floor) {
    var marker = {
        id: tag.id,
        move_layout_id: floor.id,
        marker_type: 'table',
        title: tag.letter,
        coordinates: {
            positionX: tag.positionX,
            positionY: tag.positionY,
            space: tag.space,
        },
    };
    return marker;
};
export var parseLayout = function (layout) {
    var spaces = layout.markers
        .filter(function (marker) { return marker.marker_type === 'room'; })
        .map(function (space) {
        return {
            id: space.id,
            title: space.title,
            positionX: space.coordinates.positionX,
            positionY: space.coordinates.positionY,
            openSpace: isNil(space.coordinates.openSpace) ? false : space.coordinates.openSpace,
            tables: [],
        };
    });
    // Parse tables and connect to their spaces
    layout.markers
        .filter(function (marker) { return marker.marker_type === 'table'; })
        .forEach(function (marker) {
        var tableSpace = marker.coordinates.space;
        if (!isNil(tableSpace)) {
            var correctSpace = spaces.find(function (space) { return space.title === tableSpace; });
            if (!isNil(correctSpace)) {
                var newMarker = {
                    id: marker.id,
                    space: tableSpace,
                    letter: marker.title,
                    positionX: marker.coordinates.positionX,
                    positionY: marker.coordinates.positionY,
                };
                correctSpace.tables.push(newMarker);
            }
        }
    });
    var floorImg = {
        title: layout.filename,
        url: layout.url,
    };
    return {
        id: layout.id,
        title: layout.floor_name,
        image: floorImg,
        labelColor: layout.labelColor || 'none',
        floorSize: layout.floorSize,
        spaces: spaces,
        isDefault: layout.isDefault,
    };
};
export var getOwners = function (layout) {
    var findSpaceId = function (spaceTitle) {
        var marker = layout.markers.find(function (marker) { return marker.title === spaceTitle; });
        if (marker && marker.id) {
            return marker.id;
        }
        return null;
    };
    return flatten(layout.markers.map(function (marker) {
        if (!marker.users) {
            return [];
        }
        return marker.users.map(function (user) {
            // Defaults for marker.marker_type === "room"
            var spaceId = marker.id;
            var tableId = null;
            if (marker.marker_type === 'table') {
                spaceId = findSpaceId(marker.coordinates.space);
                tableId = marker.id;
            }
            return {
                id: user.id,
                name: user.name,
                stickersNumber: user.stickersCount,
                floorId: layout.id,
                spaceId: spaceId,
                tableId: tableId,
            };
        });
    }));
};
// From FloorMarkerOwner[] to Owner[]
export var parseAssigns = function (layout, floor) {
    var ownersAssigned = [];
    if (!isNil(floor)) {
        getOwners(layout).forEach(function (owner) {
            var space = floor.spaces.find(function (space) { return space.id === owner.spaceId; });
            if (!space) {
                return;
            }
            var table = space.tables.find(function (table) { return table.id === owner.tableId; }) || null;
            ownersAssigned.push({
                id: owner.id ? owner.id : undefined,
                key: owner.id ? String(owner.id) : Math.random().toString(36).substring(7),
                name: owner.name,
                stickersNumber: owner.stickersNumber,
                floor: floor,
                space: space,
                table: table,
            });
        });
    }
    return ownersAssigned;
};
export var parseMove = function (apiResponseData) {
    var c = apiResponseData.client;
    var gis = apiResponseData.moveDetails.map(function (x) { return ({
        title: x.title,
        content: x.description,
    }); });
    return {
        name: apiResponseData.name,
        company: c,
        generalInfos: gis,
        locale: apiResponseData.language,
        stickersNumber: apiResponseData.stickersCount,
        path: apiResponseData.path,
    };
};
export var moveToWritableMove = function (move) {
    return {
        stickersCount: move.stickersNumber,
    };
};
//# sourceMappingURL=typeConversions.js.map